<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsImport-inventoryData',
  components: { PageTable },
}
</script>
